export default __webpack_public_path__ + "static/media/img-0227-netherlands-full-face.0e452600.png";